import { Fragment } from "react";
import { Link } from "react-router-dom";

import StudentTag from "../../../domains/StudentTag";
import PathHelper from "../../../helpers/PathHelper";
import SectionInterface from "../../../interfaces/SectionInterface";
import styles from "./styles.scss";

interface TagNameProps {
  section: SectionInterface;
  tag: StudentTag | null;
}

export const TagName: React.FC<TagNameProps> = ({ section, tag }) => {
  if (!tag) {
    return <>新しいメッセージを作成</>;
  }

  return (
    <Fragment>
      {tag.deleted ? (
        // 論理削除タグは生徒一覧ページに遷移させない（TAG_HISTORY-01 の閲覧通常通り維持 + リンク先 404 回避）。
        // リンク色も付けず通常テキストとして描画する
        <span>{tag.name}</span>
      ) : (
        <Link
          to={PathHelper.getStudentsPath(section.id, tag)}
          className={styles.header__link}
        >
          {tag.name}
        </Link>
      )}
      <span>へメッセージ</span>
    </Fragment>
  );
};
